import { Component, ContentChild, Input, signal, TemplateRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';

type DeviceMode = 'desktop' | 'mobile';

@Component({
  selector: 'plugin-preview-chrome',
  templateUrl: './plugin-preview-chrome.component.html',
  styleUrls: ['./plugin-preview-chrome.component.scss'],
  standalone: false,
})
export class PluginPreviewChromeComponent {
  @Input() config: ShopPlugin.ProductPagePromise.Config;
  @Input() zipCodeAvailableControl: UntypedFormControl;
  @Input() variantAvailabilityControl: UntypedFormControl;
  @Input() themeEditorUrl?: string;
  @Input() showDeviceToggle = true;

  @ContentChild(TemplateRef) bodyTemplate?: TemplateRef<unknown>;

  mode = signal<DeviceMode>('desktop');

  PluginType = ShopPlugin.ProductPagePromise.PluginType;
  LayoutMode = ShopPlugin.ProductPagePromise.LayoutMode;
}
